import { useState } from "react";
import { useSelector } from "react-redux";
import { Divider, Layout, Switch, Typography } from "antd";
import {
  BellOutlined,
  FileTextOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";

import Logo from "./Logo";
import Notificacion from "./Notificacion";
import User from "./User";
import MenuLayout from "./MenuLayout";
import { Ver } from "./Ver";
import { ModalTerminos } from "../components/modal/ModalTerminos";
import { useTerminos } from "../hooks/useTerminos";

const { Content, Sider } = Layout;
const { Link } = Typography;

////////////////////////////////////////////////////////////////////////////////
export function LayoutPage({ children }) {
  const [collapsed, setCollapsed] = useState(false);
  const [alertasAsistencias, setAlertasAsistencias] = useState(
    localStorage.getItem("alertasAsistencias") === "true"
  );
  const { logged } = useSelector((state) => state.userReducer);

  const estaLogueado = logged === 'logged';
  const onCollapse = () => setCollapsed(!collapsed);
  const cambiarAlertas = (habilitadas) => {
    setAlertasAsistencias(habilitadas);
    localStorage.setItem("alertasAsistencias", String(habilitadas));
  };

  const { loading, aceptados, aceptar } = useTerminos(estaLogueado);

  ////////////////////////////////////////////////////////////////////////////////
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={onCollapse}
        style={{ backgroundColor: "#fff" }}
      >
        <Logo isCollapsed={collapsed} />
        <User collapsed={collapsed} />
        <MenuLayout />

        {!collapsed && (
          <div className="menu-footer-panel">
            <div className="menu-footer-title">Información y avisos</div>
            <div className="menu-footer-links">
              <Link
                className="menu-footer-link"
                href="https://sigsa.blob.core.windows.net/generico/FOR-AVP-02%20Formato%20Aviso%20de%20Privacidad%20Proveedores%20Vr.1.0.pdf"
                target="_blank"
              >
                <SafetyCertificateOutlined /> Aviso de Privacidad
              </Link>
              <Link
                className="menu-footer-link"
                href="https://sigsa.blob.core.windows.net/generico/FOR-CCF-02%20Formato%20Convenio%20Confidencialidad%20Proveedores%20Vr.1.0.pdf"
                target="_blank"
              >
                <FileTextOutlined /> Términos y Condiciones
              </Link>
            </div>
            <div className="notificaciones-sonoras">
              <span className="notificaciones-label">
                <BellOutlined />
                {/* Notificaciones sonoras */}
              </span>
              <Switch
                size="small"
                checked={alertasAsistencias}
                onChange={cambiarAlertas}
              />
            </div>
          </div>
        )}

        <Divider />
        {!collapsed && <Ver />}
      </Sider>

      <Layout>
        <Content style={{ paddingLeft: 10, paddingTop: 20, paddingRight: 10 }}>
          {children}
        </Content>
      </Layout>
      <Notificacion />
      {estaLogueado && !loading && (
        <ModalTerminos visible={!aceptados} onAccept={aceptar} />
      )}
    </Layout>
  );
}
